var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShaoxing5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.637,
    height: 59.14,
    viewBox: "0 0 53.637 59.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-632.472 -5109.668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.6,4858a20.27,20.27,0,0,0-4.1-2.125v-7.362c0-1.823-1.864-3.3-4.162-3.3h-26.8c-2.3,0-4.162,1.478-4.162,3.3v7.362a20.277,20.277,0,0,0-4.1,2.125c-2.626,1.823-6.073,4.688-4.924,16.406a63.846,63.846,0,0,0,10.346,28.759,2.988,2.988,0,0,0,2.492,1.187H94.689a2.99,2.99,0,0,0,2.492-1.187,63.846,63.846,0,0,0,10.346-28.759C108.676,4862.692,105.229,4859.827,102.6,4858Z",
    transform: "translate(578.354 264.452)",
    fill: "#251e1c"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(659.5 5151.896)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47,
    fontSize: 25,
    fontFamily: "RocknRollOne-Regular, RocknRoll One",
    letterSpacing: "-0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.375,
    y: 0
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 17
  }, "\u5E74")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShaoxing5);
export default __webpack_public_path__ + "static/media/shaoxing5.ae45990e1e2ca5e780fafb85d4c18e9b.svg";
export { ForwardRef as ReactComponent };